<hb-modal-dialog heading="{{ 'LicensingDialog.Licensing' | i18next }}" [showFooter]="false">
  <div content class="form-container">
    <div class="form-group row">
      <div class="col-md-12">
        <p>{{ 'LicensingDialog.LicenceStatus' | i18next }} {{ licence.status | licenceStatus }}</p>
      </div>
      <div class="col-md-9">
        <label class="form-control-label"  for="customerName">{{ 'LicensingDialog.CustomerName' | i18next }}</label>
      </div>
      <div class="col-md-12">
        <input
          [disabled]="!hasUpdatePermission"
          [(ngModel)]="licence.customerName"
          class="form-control"
          placeholder="{{ 'LicensingDialog.CustomerName' | i18next }}"
          id="customerName"
          type="textbox"
        />
      </div>
      <div class="col-md-9">
        <label class="form-control-label" for="customerId">{{ 'LicensingDialog.CustomerId' | i18next }}</label>
      </div>
      <div class="col-md-12">
        <input
          [disabled]="!hasUpdatePermission"
          [(ngModel)]="licence.customerId"
          class="form-control"
          placeholder="{{ 'LicensingDialog.CustomerId' | i18next }}"
          id="customerId"
          type="textbox"
        />
      </div>
    </div>
    <p-panel>
      <ng-template pTemplate="header">
        <div class="header-flex">
          <div >
            {{ 'LicensingDialog.AvailableModules' | i18next }}
          </div>
          <div [style.color]="showLicenseExpiryWarning || status==='Expired' ? 'red' : 'black'">
            <span> {{ 'LicensingDialog.expiresOn' | i18next }}</span> {{ licence.expiryDate | date: 'd/M/y' }}
          </div>
        </div>
      </ng-template>

      <div class="row">
        <div class="col-md-12" *ngFor="let currentAvailableModule of availableModules">
          <div class="flex-base">
            <div class="flex-grow moduleName">{{ currentAvailableModule.name }}</div>
          </div>
        </div>
      </div>
    </p-panel>

    <div class="flex-base">
      <div class="flex-grow">{{ 'LicensingDialog.assetCount' | i18next }} {{ licence.currentAssetCount }}/{{ licence.maxAssetCount }}</div>
      <div class="version-container">{{ 'LicensingDialog.Version' | i18next }} {{ version }}</div>
    </div>
    <div *ngIf="showLicenseExpiryWarning" class="alert alert-primary custom-alert">
      {{'LicensingDialog.LicenseExpiryWarning' | i18next: { licenseExpiryDays: licenseExpiryDays } }}
    </div>
    <div *ngIf="status==='Expired'" class="alert alert-danger custom-alert">
      {{'LicensingDialog.LicenseExpiredWarning' | i18next}}
    </div>
  </div>
  <div footerContent>


    <span
      *ngIf="hasUpdatePermission"
      title="{{ 'LicensingDialog.UploadLicence' | i18next }}"
      class="btn btn-primary ui-fileupload-choose ui-button-text-icon-left ng-star-inserted pull-left"
    >
      <span class="ui-button-icon-left fa fa-upload uploadIcon"></span>
      <span class="ui-button-text ui-clickable">{{ 'LicensingDialog.Upload' | i18next }}</span>
      <input #fileInput type="file" [accept]="fileExtension" class="ng-star-inserted" (change)="fileChanged($event)" />
    </span>
    <button
      *ngIf="canUninstall && hasCreatePermission"
      [disabled]="!canUninstall"
      type="button"
      class="btn btn-primary pull-right"
      (click)="uninstall()"
    >
      {{ 'LicensingDialog.Uninstall' | i18next }}
    </button>
  </div>
</hb-modal-dialog>
